import { Component, OnInit } from '@angular/core';
import { ApiService } from 'projects/admin/src/app/services/api.service';
import { UiService } from 'projects/admin/src/app/services/ui.service';
import { UserModel } from 'projects/core/src/lib/models/user.model';
import { Router } from '@angular/router';
import { DetailModes } from '../../../../shared/constants';
import { TranslocoService } from '@ngneat/transloco';
import { BaseDetail } from 'projects/admin/src/app/classes/base-detail';
import { AuthStateService } from 'projects/admin/src/app/services/auth-state.service';
import { HelperService } from 'projects/admin/src/app/services/helper.service';

@Component({
  selector: 'app-my-profile',
  templateUrl: './my-profile.component.html',
  styleUrls: ['./my-profile.component.scss']
})
export class MyProfileComponent extends BaseDetail implements OnInit {

  public user: UserModel = null;
  public backRoute = ['/users'];
  public sysMode: string | null = null;

  protected identifier = 'my-profile';

  constructor(
    protected ui: UiService,
    protected router: Router,
    protected helper: HelperService,
    protected transloco: TranslocoService,
    private api: ApiService,
    private auth: AuthStateService
  ) {
    super(ui, router, helper, transloco);
  }

  ngOnInit(): void {
    this.sysMode = this.auth.getSysMode();
    this.setLoading();
    this.api.getMyProfile().subscribe({
      next: (result: any) => {
        this.user = new UserModel().deserialize(result.data);
        this.setInitialized(DetailModes.edit);
        setTimeout(() => {
          this.tabIndex = parseInt(localStorage.getItem('myprofile-tab'), 10);
        }, 0);
      },
      error: (error: any) => {
        this.setFailed(error);
      }
    });
  }

  public onTabChange(event: any): void {
    if (this.user !== null) {
      localStorage.setItem('myprofile-tab', event.index);
    }
    this.ui.setFocus();
  }

}
